import React from 'react';

import Banner from './banner.jsx';

import { IconArrowRight } from '$partials/icon/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/global.d.ts').Footer}
 */
const Footer = ({
    banner = false,
    bannerHeading,
    bannerText,
    isParentHomePage = false,
    links1,
    links2,
    links3,
    links4,
    logo,
    newsletterActionUrl,
    newsletterHeading,
}) => {
    const columns = [links1, links2, links3, links4];

    return (
        <>
            {banner && (
                <Banner
                    heading={bannerHeading}
                    text={bannerText} />
            )}

            <footer className={`${isParentHomePage ? 'home-page' : ''} layout-container bg-neutral-00`}>
                <div className='pb-80 sm:pb-90 pt-16 sm:pt-32'>
                    <div className='sm:layout-grid flex flex-col sm:flex-row gap-y-40'>
                        {logo && (
                            <div className='sm:w-3/12 lg:w-2/12 sm:layout-grid-col'>
                                <div className='layout-grid'>
                                    <div className='w-full layout-grid-col'>
                                        {isParentHomePage ? (
                                            <img
                                                alt={logo?.alt}
                                                className='pointer-events-none select-none'
                                                height={logo?.height}
                                                loading='lazy'
                                                src={logo?.original}
                                                width={logo?.width} />
                                        ) : (
                                            <a
                                                aria-label='Home Page'
                                                className='block'
                                                href='/'>
                                                <img
                                                    alt={logo?.alt}
                                                    className='pointer-events-none select-none'
                                                    height={logo?.height}
                                                    loading='lazy'
                                                    src={logo?.original}
                                                    width={logo?.width} />
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className='sm:w-1/12' />

                        <div className='sm:w-8/12 sm:layout-grid-col flex flex-col gap-y-32'>
                            <div className='layout-grid gap-y-32'>
                                {columns.map((column, index) => (
                                    column ? (
                                        <div
                                            className='w-6/12 sm:w-2/8 layout-grid-col rich-text-footer type-style-body'
                                            dangerouslySetInnerHTML={{ __html: column }}
                                            key={index} />
                                    ) : null
                                )).filter(Boolean)}
                            </div>

                            {newsletterActionUrl && (
                                <div className='layout-grid'>
                                    <div className='w-full sm:w-4/8 layout-grid-col flex flex-col gap-8'>
                                        {newsletterHeading && (
                                            <h2>{newsletterHeading}</h2>
                                        )}

                                        {/*
                                        * Mailchimp embedded form (direct POST, no server round-trip).
                                        * NOTE: the bot honeypot (`b_<u>_<id>`) and GDPR hidden fields
                                        * are Mailchimp account/list-specific and should be added to
                                        * match the configured list.
                                        */}
                                        <form
                                            action={newsletterActionUrl}
                                            className='flex gap-8'
                                            method='post'
                                            name='mc-embedded-subscribe-form'>
                                            <label
                                                className='sr-only'
                                                htmlFor='footer-newsletter-email'>
                                                Email
                                            </label>

                                            <input
                                                required
                                                autoComplete='email'
                                                className='form-input'
                                                id='footer-newsletter-email'
                                                name='EMAIL'
                                                placeholder='Email'
                                                type='email' />

                                            <button
                                                className='button-hollow'
                                                type='submit'>
                                                <span>Submit</span>
                                                <IconArrowRight
                                                    height={20}
                                                    width={20} />
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Footer;
